const SESSION_KEYS = {
	applications: new Set(),
	essays: new Set(),
	feedback: new Set(),
	documents: new Set(),
	recommendations: new Set(),
	assignments: new Set(),
	messages: new Set(),
}

export const counselorSeenDedupe = {
	tryMark(category, key) {
		const id = String(key || '').trim()
		if (!id) return false
		const set = SESSION_KEYS[category]
		if (!set) return false
		if (set.has(id)) return false
		set.add(id)
		return true
	},

	unmark(category, key) {
		const id = String(key || '').trim()
		if (!id) return
		SESSION_KEYS[category]?.delete(id)
	},

	hasMark(category, key) {
		const id = String(key || '').trim()
		if (!id) return false
		return SESSION_KEYS[category]?.has(id) || false
	},

	reset() {
		Object.values(SESSION_KEYS).forEach(set => set.clear())
	},
}
